import { event } from '@uhg-abyss/web/tools/event';

const techincalLinkRedirectHandler = (
  redirect,
  name,
  href,
  isInternal,
  componentName
) => {
  if (!isInternal) {
    event('EXIT_LINK_NAVIGATE', {
      linkText: name,
      linkUrl: componentName === 'ApplicationLink' ? redirect : href,
    });
    window.open(
      `/api/identity/ohid/superusersso?redirect=${redirect}`,
      '_blank'
    );
  } else {
    event('NAVIGATION_CLICK', { name });
    window.location.replace(redirect);
  }
};

export const handleLinkClickFunction = ({
  hasPermission,
  toggleModal,
  name,
  href,
  redirect,
  isSuperUser,
  isUhcInsightsUser,
  componentName,
  onClick,
  isDownload,
  isInternal,
}) => {
  if (!hasPermission) {
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
    return;
  }

  if (componentName === 'LinkFromHeaderContentLagoon') {
    onClick({ text: name, isDownload, link: href });
  }

  if (isSuperUser || isUhcInsightsUser) {
    techincalLinkRedirectHandler(
      redirect,
      name,
      href,
      isInternal,
      componentName
    );
    return;
  }
  if (isInternal) {
    event('NAVIGATION_CLICK', { name });
    window.location.replace(redirect);
  } else {
    event('EXIT_LINK_NAVIGATE', {
      linkText: name,
      linkUrl: componentName === 'ApplicationLink' ? redirect : href,
    });
    window.open(redirect, '_blank');
  }
};

export const handleLinkClickFunctionForSubMenuDropdownContent = ({
  hasPermission,
  toggleModal,
  name,
  href,
  redirect,
  isSuperUser,
  isUhcInsightsUser,
  componentName,
  onClick,
  isDownload,
  isInternal,
  flyout,
}) => {
  if (!hasPermission) {
    toggleModal({ key: 'permissions', isOpen: true, toolName: name });
    return;
  }

  if (componentName === 'LinkFromHeaderContentLagoon') {
    onClick({ text: name, isDownload, link: href });
  }

  if (isSuperUser || isUhcInsightsUser) {
    techincalLinkRedirectHandler(
      redirect,
      name,
      href,
      isInternal,
      componentName
    );
    flyout.close();
    return;
  }
  if (isInternal) {
    event('NAVIGATION_CLICK', { name });
    window.location.replace(redirect);
  } else {
    event('EXIT_LINK_NAVIGATE', {
      linkText: name,
      linkUrl: componentName === 'ApplicationLink' ? redirect : href,
    });
    window.open(redirect, '_blank');
  }
  flyout.close();
};

// This function is a mini lift to for the new breakout system.
// This lets continue to use the lagoon links with "#" at the beginning for
// the large AppNav dropdown links.
export const removeHashFromUrl = (url) => {
  return url && typeof url === 'string' && url.startsWith('#')
    ? url.substring(1)
    : url;
};

export const getAppLinkHandler = (link, queryParam, queryParamData) => {
  if (queryParam) {
    return link.replace(queryParam, queryParamData[queryParam]);
  }
  return link;
};
